const EXCLUDED_IFC_TYPES = ["IfcSpace", "IfcStairFlight", "IfcColumn", "IfcMember", "IfcRailing"];

let lastHighlightedEntityId = null;
let hoverHandler = null;
let pickHandler = null;

const entityInteraction = (viewer, isInfoMode, setEntityData, setPopoverPosition, setAnchorEl) => {
    if (!viewer) return;

    //removing old event listeners
    if (hoverHandler) viewer.cameraControl.off("hover", hoverHandler);
    if (pickHandler) viewer.cameraControl.off("picked", pickHandler);

    if (!isInfoMode) {
        // Disable all input events
        viewer.cameraControl._eventSubs = {};
        viewer.cameraControl._eventSubsNum = {};

        // Reset entity highlighting
        if (lastHighlightedEntityId) {
            viewer.scene.setObjectsHighlighted([lastHighlightedEntityId], false);
            lastHighlightedEntityId = null;
        }
        viewer.scene.setObjectsHighlighted([], false); // 🔴 FIX: Use this instead of clearHighlightedObjects()
        if (hoverHandler) viewer.cameraControl.off("hover", hoverHandler);
        if (pickHandler) viewer.cameraControl.off("picked", pickHandler);
        // Close any open popover
        setEntityData(null);
        setAnchorEl(null);

        // Ensure handlers are completely removed
        hoverHandler = null;
        pickHandler = null;

        return;
    }

    console.log("✅ Enabling Entity Interaction...");
    viewer.scene.input.setEnabled(true);
    viewer.cameraControl.pointerEnabled = true;

    // Define event handlers
    hoverHandler = (pickResult) => {
        if (!pickResult?.entity) {
            if (lastHighlightedEntityId) {
                viewer.scene.setObjectsHighlighted([lastHighlightedEntityId], false);
                lastHighlightedEntityId = null;
            }
            return;
        }

        const entity = pickResult.entity;
        console.log("🔵 Hovering over entity:", entity.id);

        const parentModel = entity.model;
        const metadata = viewer.metaScene.metaObjects[entity.id];

        if (parentModel?.id === "myIfcModel" && metadata && !EXCLUDED_IFC_TYPES.includes(metadata.type)) {
            if (lastHighlightedEntityId && lastHighlightedEntityId !== entity.id) {
                viewer.scene.setObjectsHighlighted([lastHighlightedEntityId], false);
            }
            viewer.scene.setObjectsHighlighted([entity.id], true);
            lastHighlightedEntityId = entity.id;
        }
    };

    pickHandler = (pickResult) => {
        if (!pickResult?.entity) return;

        const selectedEntity = pickResult.entity;
        console.log("🟢 Clicked on entity:", selectedEntity.id);

        const parentModel = selectedEntity.model;
        const metaObject = viewer.metaScene.metaObjects[selectedEntity.id];

        if (parentModel?.id === "myIfcModel" && metaObject && !EXCLUDED_IFC_TYPES.includes(metaObject.type)) {
            setEntityData({
                id: selectedEntity.id,
                metadata: {
                    name: metaObject.name,
                    type: metaObject.type,
                    parentName: metaObject.parent?.name,
                }
            });

            const canvasCoords = pickResult._canvasPos;
            setPopoverPosition({
                top: Math.min(canvasCoords[1] + 10, window.innerHeight - 200),
                left: Math.min(canvasCoords[0] + 20, window.innerWidth - 300),
            });
            setAnchorEl(document.body);
        }
    };

    // Attach event listeners
    viewer.cameraControl.on("hover", hoverHandler);
    viewer.cameraControl.on("picked", pickHandler);
};

export default entityInteraction;
